module.exports = __webpack_public_path__ + "img/event-frame02.ca13f2d5.png";